// Generated with util/create-component.js
import React from "react";
import iconDefinitions from "./iconValues";
import { IconProps } from "./Icon.types";
import "./Icon.scss";

const Icon: React.FC<IconProps> = ({ value }) => (
  <span className={`mp-atoms-icon--main`}>
    <svg
      viewBox={iconDefinitions[value].viewBox}
      focusable="false"
      aria-hidden="true"
      data-icon={value}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      {iconDefinitions[value].icon}
    </svg>
  </span>
);

export default Icon;
